// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._deephxu2YQ7P7Aac3kw{grid-template-columns:1fr 52px 1fr;place-items:center;display:grid}._nIpWFdQBUI6XPUtbZtH{background-color:var(--background-neutral-default);border-radius:4px;justify-content:center;align-items:center;width:100%;height:120px;display:flex}.Lcz8Yllz8Uh_baYaGvpT>svg{height:var(--svg-height)}.jZMzSebmUfwkA1tpdiBa{background-color:var(--background-neutral-default);border-radius:50%;justify-content:center;align-items:center;width:28px;height:28px;display:flex}.rLG7yZQnfFIKWOnaEwxh{grid-column:span 3;width:100%;margin-top:18px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `_deephxu2YQ7P7Aac3kw`,
	"integrationIcon": `_nIpWFdQBUI6XPUtbZtH`,
	"integrationIconCustom": `Lcz8Yllz8Uh_baYaGvpT`,
	"typeIcon": `jZMzSebmUfwkA1tpdiBa`,
	"select": `rLG7yZQnfFIKWOnaEwxh`
};
export default ___CSS_LOADER_EXPORT___;
